import { TypePolicies } from '@apollo/client';

import { membershipTypePolicy } from '@ocx/data-membership';
import { offersTypePolicy } from '@ocx/data-offers';
import { awardTypePolicy } from './award.type-policy';
import { externalOffersTypePolicy } from './external-offers.type-policy';
import { surveyTypePolicy } from './survey.type-policy';

// Both data-membership and data-offers register fields on the Membership type
// (`isCompleted` and `offers` respectively). A naive spread would clobber one set;
// merge the `Membership.fields` maps explicitly.
const mergedMembership: TypePolicies['Membership'] = {
  ...membershipTypePolicy.Membership,
  ...offersTypePolicy.Membership,
  fields: {
    ...membershipTypePolicy.Membership?.fields,
    ...offersTypePolicy.Membership?.fields,
  },
};

export const apolloCacheTypePolicies: TypePolicies = {
  Customer: {
    // Needed to make cache working properly
    keyFields: ['uuid'],
  },
  CommunicationPreference: {
    keyFields: false,
  },
  SiteSystemCarWashItem: {
    // SiteSystemCarWashItem does not have any ID fields for caching
    keyFields: ['productCode', 'posCode', 'posCodeModifier'],
  },
  LoyaltyEvent: { keyFields: ['eventType', 'createdAt'] },
  TotalAvailableRollback: { keyFields: ['locationUuid', 'fuelProductGroup', ['id']] },
  ...awardTypePolicy,
  ...externalOffersTypePolicy,
  ...surveyTypePolicy,
  Membership: mergedMembership,
};
